import { createTheme } from '@mui/material/styles'

export const cardReplayTheme = createTheme({
  cssVariables: {
    cssVarPrefix: 'cr',
    colorSchemeSelector: 'data',
  },
  modularCssLayers: '@layer theme, base, mui, components, utilities;',
  colorSchemes: {
    light: {
      palette: {
        primary: { main: '#12243e' },
        secondary: { main: '#6e759f' },
        success: { main: '#22c7fb', contrastText: '#12243e' },
        error: { main: '#ff364e' },
        warning: { main: '#ffa319' },
        info: { main: '#33c2ff' },
        background: { default: '#ffffff', paper: '#ffffff' },
        text: { primary: '#12243e', secondary: '#6e759f' },
      },
    },
    dark: {
      palette: {
        primary: { main: '#ffffff' },
        secondary: { main: '#9ea4c1' },
        success: { main: '#22c7fb', contrastText: '#12243e' },
        error: { main: '#ff364e' },
        warning: { main: '#ffa319' },
        info: { main: '#33c2ff' },
        background: { default: '#080f30', paper: '#2d4064' },
        text: { primary: '#ffffff', secondary: '#9ea4c1' },
      },
    },
  },
  focusVisible: {
    outlineColor: '#22c7fb',
  },
  shape: {
    borderRadius: 6,
  },
  typography: {
    fontFamily: "'CardReplay Legacy', Avenir, 'Avenir Next', sans-serif",
    button: {
      fontWeight: 500,
      textTransform: 'none',
    },
  },
  components: {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(0, 0, 0, 0.055)',
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 6,
          paddingInline: 16,
        },
        sizeSmall: {
          fontSize: '0.866667rem',
          lineHeight: 1.75,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          boxShadow:
            '0 0 0 0 rgba(0,0,0,0.2), 0 0 7px 1px rgba(0,0,0,0.14), 0 3px 5px 2px rgba(0,0,0,0.12)',
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '15px 24px',
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: 0,
          marginRight: 8,
          textTransform: 'none',
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        list: {
          padding: 0,
        },
        paper: {
          padding: 18,
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: ({ theme }) => ({
          marginBlock: 1,
          color: theme.palette.text.secondary,
          fontSize: 14,
          transition: 'all 0.2s',
          '&:hover, &:active, &.Mui-selected': {
            backgroundColor: theme.palette.action.hover,
            color: theme.palette.text.primary,
          },
        }),
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: ({ theme }) => ({
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.text.secondary,
          },
          '&.Mui-focused:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.text.primary,
          },
        }),
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: ({ theme }) => ({
          fontSize: 13,
          fontWeight: 700,
          transition: 'all 0.2s',
          '&.Mui-selected': {
            boxShadow: '0 2px 8px rgba(34, 199, 251, 0.35)',
          },
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        }),
      },
    },
  },
})
